import type {Ref} from 'vue';
import {ref} from 'vue';
import {businessReferralsEndpoints} from '@registry';
import {defineStore} from 'pinia';
import {useTranslation} from '#imports';
import {readonlyState} from '@malt/utils';
import type {ReferrerAlertsResource} from '@api';
import {ReferrerAlertTypeResource} from '@api';

export interface Alert {
    message: string;
    linkLabel: string;
    link: string;
}

export const useAlertStore = defineStore('alert-store', () => {
    const alert: Ref<Alert | undefined> = ref();
    const {t} = useTranslation();

    async function fetchBusinessReferralAlert() {
        const alertsResource = await businessReferralsEndpoints.getReferrerAlerts();
        alert.value = toAlert(alertsResource);
    }

    function toAlert(alertsResource: ReferrerAlertsResource): Alert | undefined {
        const containsBankInfoAlert = alertsResource.alerts!.includes(ReferrerAlertTypeResource.BankInformation);
        if (containsBankInfoAlert) {
            return {
                message: t('business-referral.alert.no.bank.details'),
                linkLabel: t('business-referral.alert.no.bank.details.link.label'),
                link: '/company/payments',
            };
        }
        const containsComplianceDocumentsAlert = alertsResource.alerts!.includes(ReferrerAlertTypeResource.ComplianceDocuments);
        if (containsComplianceDocumentsAlert) {
            return {
                message: t('business-referral.alert.no.compliance.documents'),
                linkLabel: t('business-referral.alert.no.compliance.documents.link.label'),
                link: '/company/compliance',
            };
        }
    }

    return {
        alert: readonlyState(alert),
        fetchBusinessReferralAlert,
    };
});
